import { showToast, TOAST_TYPE } from '@shared/components/messages-and-errors/ToastsNotifications';
import { CLUSTER_TOAST_ID, clusterMessages } from '@domain/dashboard/cluster/cluster.constants';
import {
    GET_SEGMENTS_REQUEST_SUCCEEDED,
    EDIT_SEGMENT,
    getCurrentTagGroups,
    editGroup,
    convertSegmentPayload,
} from '@domain/segments';
import { showSuccessToast } from '@shared/toasts/toasts.state';
import { setModalDraftClusters } from '@domain/budget-manager/modal/budget-manager-campaigns-modal.state';
import { getBudgetManagerTagGroup, isBudgetManagerTagGroup } from '@domain/budget-manager/budget-manager.utils';
import { updateCampaignsTagName } from '../campaigns/campaigns.state';
import { createMiddleware } from '../../../shared/redux';
import { types as clusterActionTypes, getClusters } from './cluster.state';

export const clustersMiddleware = createMiddleware({
    [GET_SEGMENTS_REQUEST_SUCCEEDED]: (state) => {
        const tagGroup = getBudgetManagerTagGroup(state.segments.currentSegments.data);
        return tagGroup ? getClusters({ tagGroupId: tagGroup.id }) : [];
    },
    [EDIT_SEGMENT]: (state, action) => {
        const { group } = action.payload;
        return isBudgetManagerTagGroup(group.slug)
            ? getClusters({ tagGroupId: group.id }) : [];
    },
    [clusterActionTypes.EDIT_CLUSTER_REQUEST_SUCCEEDED]: (state, action) => {
        const { tagGroup, name, previousCluster } = action.requestAction.payload;
        const currentTagGroups = getCurrentTagGroups(state);
        const budgetManagerTagGroup = getBudgetManagerTagGroup(currentTagGroups.data);
        const updatedTaggedCampaigns = Object.values(budgetManagerTagGroup.taggedCampaigns).map(
            (campaign: any) => {
                const [tag] = campaign.tags;

                if (tag === previousCluster.name) {
                    return {
                        ...campaign,
                        tags: [name],
                    };
                }

                return campaign;
            },
        );
        const budgetManagerGroupConverted = convertSegmentPayload({
            ...budgetManagerTagGroup,
            tagged_campaigns: updatedTaggedCampaigns,
        });

        return [
            showSuccessToast({ message: clusterMessages.SUCCEEDED }),
            editGroup({
                group: {
                    ...budgetManagerTagGroup,
                    tagged_campaigns: updatedTaggedCampaigns,
                },
            }),
            /*
            * @TODO New Clusters API - to update here
            * */
            setModalDraftClusters({
                ...budgetManagerGroupConverted,
            }),
            updateCampaignsTagName({
                tagGroupId: tagGroup,
                newTagName: name,
                previousTagName: previousCluster.name,
            }),
        ];
    },
    [clusterActionTypes.EDIT_CLUSTER_REQUEST_FAILED]: (state, action) => {
        const { response } = action.payload;
        const errors = Object.values(response?.data?.errors || {});
        const error = errors[0] || clusterMessages.FAILED;

        showToast(
            error,
            TOAST_TYPE.ERROR,
            { toastId: CLUSTER_TOAST_ID },
        );
    },
});
